import styleInject from '../../node_modules/style-inject/dist/fb3a8d84bb477a96e56a5e12f7d7ac81b9d9799a9277fe852d93ab86a1b81224.cfe-internal.js';

var css_248z = "._1VN1U{display:flex;align-items:center;justify-content:center;font-size:14px;white-space:pre}._32Ty5{margin-right:8px}._3I8D6{margin-left:8px}._1qI-M{margin:-10px -15px}._v6zNZ{width:100%;text-align:center}";
var styles = {"pagination":"_1VN1U","previousButton":"_32Ty5","nextButton":"_3I8D6","btnIcon":"_1qI-M","input":"_v6zNZ"};
var stylesheet="._1VN1U{display:flex;align-items:center;justify-content:center;font-size:14px;white-space:pre}._32Ty5{margin-right:8px}._3I8D6{margin-left:8px}._1qI-M{margin:-10px -15px}._v6zNZ{width:100%;text-align:center}";
styleInject(css_248z);

export { styles as default, stylesheet };
